// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation } from "redux-query-react";
import * as QueryString from 'query-string';
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
/**
 * Update Benchmark Configuration
 * Bulk Update Benchmark Configuration
 */
export function postBenchmarksConfigurationRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.includeInvestor === null || requestParameters.includeInvestor === undefined) {
        throw new runtime.RequiredError('includeInvestor', 'Required parameter requestParameters.includeInvestor was null or undefined when calling postBenchmarksConfiguration.');
    }
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.includeInvestor !== undefined) {
        queryParameters['includeInvestor'] = requestParameters.includeInvestor;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/octet-stream';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/benchmarks/upload-configuration` + queryString,
        meta,
        update: requestConfig.update || {
            BenchmarksConfiguration: (prevValue, transformedValue) => {
            }
        },
        optimisticUpdate: requestConfig.optimisticUpdate || {
            BenchmarksConfiguration: (prevValue) => {
            }
        },
        rollback: requestConfig.rollback || {
            BenchmarksConfiguration: (initialValue, currentValue) => {
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: requestParameters.body,
    };
    config.queryKey = requestConfig.queryKey || `PostBenchmarksConfiguration-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Update Benchmark Configuration
* Bulk Update Benchmark Configuration
*/
/**
 * Mutation hook to upsert an
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an
 */
export const usePostBenchmarksConfiguration = (customQueryConfig) => {
    return useMutation((includeInvestor, body, customQueryParam) => postBenchmarksConfigurationRaw({ includeInvestor, body }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postBenchmarksConfiguration(requestParameters, requestConfig) {
    return postBenchmarksConfigurationRaw(requestParameters, requestConfig);
}
